import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PartyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: 'flex',
      flex: '1',
      paddingLeft: theme.spacing(1),
    },
    brdBtm: {
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
      padding: theme.spacing(1, 0),
      pageBreakInside: 'avoid',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    labelCol: {
      minWidth: '25%',
      maxWidth: '25%',
      marginRight: theme.spacing(3),
    },
    flexGrow: {
      flex: '1',
    },
    ml1: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    mb1: {
      marginBottom: theme.spacing(1),
    },
    minWidth: {
      marginRight: theme.spacing(1),
      minWidth: '100px',
      display: 'inline-block',
      fontWeight: 500,
    },
    danger: {
      background: '#FDECEA',
      color: '#B3150A',
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
      '& a': {
        color: '#B3150A',
      },
    },
    warning: {
      background: '#FDF4E7',
      color: '#C77700',
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
      '& a': {
        color: '#C77700',
      },
    },
    success: {
      background: '#EFF7EE',
      color: '#3B873E',
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    fontSizeNormal: {
      fontSize: pxToRem(12),
    },
    bold: {
      fontWeight: 800,
      textTransform: 'uppercase',
    },
    zeroMarginBottom: {
      marginBottom: theme.spacing(0),
    },
    paddingLeftRemoved: {
      paddingLeft: theme.spacing(0),
    },
  }),
);

const Sdn: React.FC<PartyOrderInsightsProps> = ({ party, isPdf }) => {
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    party.risks,
    RiskCategory.SDN,
  );
  const parentRiskSeverity = getParentSeverity(party.risks, RiskCategory.SDN);
  const classes = useStyles();

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.flex, isPdf ? classes.paddingLeftRemoved : '')}>
        <div className={classes.labelCol}>
          <span className={classes.flexCenter}>
            <OrderInsightsRiskIcon riskSeverity={parentRiskSeverity} isPdf={isPdf} />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              SDN:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          {parentRiskSeverity === 'Success' && (
            <Typography variant="body1" className={clsx(classes.fontSizeNormal, isPdf ? classes.zeroMarginBottom : '')}>
              No Matches Found
            </Typography>
          )}
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
          />
        </div>
      </div>
    </div>
  );
};

export default Sdn;
